<template>
    <div class="form-group row">
        <label for="searchefedrous" class="col-md-4 col-form-label text-md-right">Αναζήτηση Εφέδρων</label>
        <div class="col-md-5">
            <input type="text" @keypress="submitAtReturn" id="searchefedrous" v-model="efsa" class="form-control"
                   placeholder="Εισάγετε Α.Σ.Μ Εφέδρων">
        </div>
        <div class="col-md-1">
            <button class="btn btn-secondary" v-on:click.prevent="searchEfedrous" type="button">
                <font-awesome-icon :icon="['fas', 'search']"/>
            </button>
        </div>
    </div>
</template>

<script>
export default {
    props: ['rows'],
    data: function () {
        return {
            efsa: '',
        }
    },
    methods: {
        submitAtReturn: function (event) {
            if (event.keyCode != 13) return;
            event.preventDefault();
            this.searchEfedrous();
        },
        searchEfedrous: function () {
            if (this.efsa === '') return;

            let userExistsInTeam = this.$props.rows.find((row) => {
                return row.efsa === this.efsa;
            });

            if (userExistsInTeam) return;

            this.efsa = this.$validator.stripTags(this.efsa);

            if (!this.$validator.onlyNumbers(this.efsa)) {
                let show_error = true;
                let error_message = 'Για την αναζήτηση εφέδρων επιτρέπονται μόνο αριθμητικοί χαρακτήρες. Παρακαλούμε δοκιμάστε εκ νέου.'
                this.$emit('error', show_error, error_message)
                return;
            }

            let url = "/users/";   

            /*if(this.$store.getters.userRole == "ROLE_MANAGER") {
                url += this.efsa + '/mee/' + this.$store.getters.meeResponsible;
            } else if(this.$store.getters.userRole == "ROLE_SXHMATISMOS") {
                url += this.efsa + '/deps/' + this.$store.getters.meeResponsible;
            } else {*/
                url += this.efsa;
            /*}*/

            this.$store.dispatch('loading');
            
            this.$http.get(url)
                .then((response) => {
                    let resp = response.data;
                    if (!resp.efedros) {
                        if (this.$router.currentRoute.path === '/teams') {
                            this.$emit('error');
                            return;
                        }
                        $('.toast').toast({delay: 1000});
                        $('.toast').toast('show');
                        return;
                    }

                    let efedros = resp.efedros;
                    let data = {
                        'efsa': this.efsa,
                        'efEpwnymo': efedros.efEpwnymo,
                        'efOnoma': efedros.efOnoma
                    };
                    this.$props.rows.push(data);
                })
                .catch((e) => {
                    console.error(e);
                })
                .finally(() => this.$store.dispatch('stop_loading'));
        }
    }
}
</script>